/**
 * The omnium "o", drawn rather than typed.
 *
 * A text glyph is centred by its line box, not by its ink — an "o" uses none of
 * the ascender or descender space that box reserves, so it always sits low and
 * needs a per-size nudge to look right. Geometry has no such problem: the ring
 * is centred in its viewBox at every size.
 */
export function BrandMark({ size = 34 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <circle cx="12" cy="12" r="7" fill="none" stroke="currentColor" strokeWidth="3.4" />
    </svg>
  );
}
